import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GtmDirective } from '@directives';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [CommonModule, GtmDirective, TranslateModule],
  exports: [CommonModule, GtmDirective, TranslateModule],
})
export class CommonStandaloneModule {}
